    import axios from 'axios';


    // 개발 서버의 동일 출처 프록시만 사용한다. 운영 API 주소와 인증 로직은 유지한다.
    const apiUrl = process.env.NODE_ENV === 'development'
      ? '/api'
      : 'https://k-aquas.dromii.com/api';
    const contentType = 'application/json';

    // -----------------------------
    // ✅ 공통 응답 포맷
    // -----------------------------
    export class ApiResponse {
    static success(data) {
        return { error: false, code: 200, data };
    }
    static error(message, code = 500) {
        console.error(message);
        return { error: true, code, message };
    }
    }

    // -----------------------------
    // ✅ 토큰 유틸리티
    // -----------------------------
    export const getAccessToken = () => localStorage.getItem("accessToken");
    export const getRefreshToken = () => localStorage.getItem("refreshToken");
    export const setTokens = ({ access, refresh }) => {
        if (access) localStorage.setItem("accessToken", access);
        if (refresh) localStorage.setItem("refreshToken", refresh); // undefined 덮어쓰기 방지
      };
      

      export async function refreshAccessToken() {
        const refresh = getRefreshToken();
        if (!refresh) return null;
      
        try {
          const res = await axios.post(`${apiUrl}/token/refresh/`, { refresh });
          // access는 무조건, refresh는 있으면 저장
          setTokens({ access: res.data.access, refresh: res.data.refresh });
          return res.data.access;
        } catch (err) {
          console.error("토큰 갱신 실패", err);
          return null;
        }
      }
      

    // -----------------------------
    // ✅ secureFetch (자동 재시도)
    // -----------------------------
    export async function secureFetch(url, options = {}) {
    let token = getAccessToken();
    if (!token) token = await refreshAccessToken();
    if (!token) return null;

    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': contentType,
        ...options.headers,
    };

    try {
        const res = await fetch(url, { ...options, headers });
        if (res.status === 401) {
        const newToken = await refreshAccessToken();
        if (!newToken) return null;
        headers.Authorization = `Bearer ${newToken}`;
        return fetch(url, { ...options, headers });
        }
        return res.json();
    } catch (err) {
        console.error("secureFetch 실패:", err);
        return null;
    }
    }

    // -----------------------------
    // ✅ 인증 관련 API
    // -----------------------------
    export async function loginUser(email, password) {
    try {
        const res = await axios.post(`${apiUrl}/token/`, { email, password });
        if (res.data.access && res.data.refresh) {
        setTokens(res.data);
        return { isLoggedIn: true, data: res.data };
        }
        throw new Error("토큰이 반환되지 않았습니다.");
    } catch (err) {
        console.error("로그인 실패:", err);
        return { isLoggedIn: false, message: err.message };
    }
    }

    export async function registerUser(username, email, password, phone_number,company_id) {
    try {
        const res = await axios.post(`${apiUrl}/register/`, {
        username, email, password, phone_number,company_id
        });
        if (res.data.access && res.data.refresh) {
        return { isRegistered: true, data: res.data };
        }
        throw new Error("토큰이 반환되지 않았습니다.");
    } catch (err) {
        console.error("회원가입 실패:", err);
        return { isRegistered: false, message: err.message };
    }
    }
    //회사정보
    export const fetchCompanyList = async () => {
        const url = `${apiUrl}/companies/`;
        const res = await axios.get(url, {
            headers: { apikey:process.env.REACT_APP_V3_API_KEY },
        });
        return res.data;
    };
    // -----------------------------
    // ✅ 회원관리 관련 API
    // ----------------------------- 
    export const fetchUserApprovalList = async () => {
        const url = `${apiUrl}/user-management/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
        });
        return res.data;
    };
    export const fetchUserApproval = async (user_id, action) => {
        const url = `${apiUrl}/user-management/`;
        const res = await axios.post(
          url,
          { user_id, action }, // JSON 객체로 전달
          {
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
              'Content-Type': 'application/json',
            },
          }
        );
        return res.data;
      };

      
      // 사용자 조회
    export const fetchUserList = async (filter, is_active) => {
        const url = `${apiUrl}/users/`;
        const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        params: { filter, is_active }, // ✅ 올바른 위치
        });
        return res.data;
    };
    //특정 사용자 조회
    export const fetchUserSearch = async (id) => {
        const url = `${apiUrl}/users/${id}`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
        });
        return res.data;
    };
    //사용자 정보 변경
    export const fetchUserInfoChange = async (id, data) => {
      const url = `${apiUrl}/users/${id}/`; // 끝에 슬래시 포함 권장 (DRF 호환용)
      const res = await axios.patch(
        url,
        data, // 두 번째 인자는 실제 수정할 데이터
        {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
        }
      );
      return res.data;
    };
    

    //사용자 삭제
    export const fetchUserDelete = async (id) => {
        const url = `${apiUrl}/users/${id}`;
        const res = await axios.delete(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
        });
        return res.data;
    };

    //사용자 로그 조회
    export const fetchUserLogList = async () => {
        const url = `${apiUrl}/common/logs/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
        });
        return res.data;
    };



    // -----------------------------
    // ✅ 전국오염원조사 관련 API
    // -----------------------------
    export const fetchPollutionData = async (year, ri) => {
    return secureFetch(`${apiUrl}/pollution/filter/?year=${year}&ri=${encodeURIComponent(ri)}`);
    };

    export const fetchPollutionavgData = async (classification, year) => {
    return secureFetch(`${apiUrl}/pollution/filter/?classification=${classification}&year=${year}`);
    };

    export const fetchPollution63Data = async (year, area_name) => {
    return secureFetch(`${apiUrl}/pollution/filter63/?year=${year}&area_name=${area_name}`);
    };

    // -----------------------------
    // ✅ 오염원 관련 API
    // -----------------------------
    // 우선관리지역 프로젝트 실행 API
    export const fetchPriorityArea = async (pollutionGroup, year, date, weights,covermap_pcod) => {
    const url = `${apiUrl}/pollution/priorityarea/${pollutionGroup}/${year}/${date}/`;
    try {
        const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        params: weights,covermap_pcod
        });
        return res.data;
    } catch (err) {
        console.error("우선관리지역 실패:", err);
        throw err;
    }
    };
    // 우선관리지역 데이터셋 목록 조회 API
    export const fetchPollutionDataSetList = async (area) => {
    const url = `${apiUrl}/pollution/filterrank/list`;
    const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        // 처리 현황 폴링은 반드시 최신 상태를 읽어야 한다. 브라우저가 같은 GET
        // 응답을 재사용하면 완료·실패·취소 상태가 오래된 "처리 중"으로 남는다.
        params: { ...(area ? { area } : {}), _: Date.now() },
    });
    return res.data;
    };
    // 우선관리지역 데이터셋 정보조회 API
    export const fetchPollutionDataSetInfo = async (pcode, area) => {
    const url = `${apiUrl}/pollution/filterrank/`;
    const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        params: area ? { pcode, area } : { pcode },
    });
    return res.data;
    };
    
    // 우선관리지역 데이터셋 삭제 API
    export const fetchPollutionDataSetDelete = async (pcode, { cancel = false } = {}) => {
        const url = `${apiUrl}/pollution/filterrank/delete/${pcode}/${cancel ? '?cancel=true' : ''}`;
        const res = await axios.delete(url, {
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        });
        return res.data;
    };

    // -----------------------------
    // ✅ 축산농가 위치 API
    // -----------------------------
    export const fetchLivestockHouse = async (mgt_no, area_code, state, type, area) => {
    const params = new URLSearchParams();
    if (mgt_no) params.append("mgt_no", mgt_no);
    if (area_code) params.append("area_code", area_code);
    if (state) params.append("state", state);
    if (type) params.append("type", type);
    if (area) params.append("area", area);

    return secureFetch(`${apiUrl}/pollution/livestockhouse/?${params.toString()}`);
    };


    export const fetchLivestockArea = async (year,month, area_name, area) => {
      const url = `${apiUrl}/pollution/livestockscale63/`;
      const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
          params: area ? { year,month,area_name,area } : { year,month,area_name },
      });
      return res.data;
    };



    // -----------------------------
    // ✅ 토지피복도 관련 API
    // -----------------------------
    //토지피복도 목록 조회 API
    export const fetchCommonList = async (pcode,year,date,area) => {
        const url = `${apiUrl}/common/covermap-list/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
            params: { pcode,year,date,area },
        });
        return res.data;
    };
    //토지피복도 정보 조회 API
    export const fetchCommonInfo = async (pcode,area) => {
        const url = `${apiUrl}/common/covermap-info/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
            params: { pcode,area },
        });
        return res.data;
    };

    //토지피복도 유역별 정보 조회
    export const fetchCommonAreaInfo = async (pcode,year,date,area,area_number) => {
      const url = `${apiUrl}/common/covermap-info/`;
      const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
          params: { pcode,year,date,area,area_number},
      });
      return res.data;
  };

    // -----------------------------
    // ✅ 센티널데이터 관련 API
    // -----------------------------   
    //센티널구름량 목록 조회 
    export const fetchCloudCheckData = async (area, formattedDate) => {
        try {
          const url = `${apiUrl}/common/cloud-check/${area}/${formattedDate}`;
          const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
          });
          return res.data;
        } catch (error) {
          console.error("Cloud Check API 호출 오류:", error);
          throw error;
        }
      };
    //센티널이미지 목록 조회 
    export const fetchSatelliteList = async () => {
        const url = `${apiUrl}/common/sentinel-image-list/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
        });
        return res.data;
    };
    //센티널이미지 정보 조회 API
    export const fetchSatelliteInfo = async (pcode,year,date,evalscript,sr_state) => {
        const url = `${apiUrl}/common/covermap-info/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
            params: { pcode,year,date,evalscript,sr_state },
        });
        return res.data;
    };
    //센티널이미지 정보 상세 조회 API
    export const fetchSatelliteDetailInfo = async (pcode,year,date,evalscript,sr_state) => {
        const url = `${apiUrl}/common/covermap-info/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
            params: { pcode,year,date,evalscript,sr_state },
        });
        return res.data;
    };
    // -----------------------------
    // ✅ 퇴비 탐지 관련 API
    // -----------------------------  
    // 퇴비 탐지 프로젝트 목록 API
    export const fetchDetectDataSetList = async (area) => {
        const url = `${apiUrl}/detect/project-list/`;
        const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
            params: { ...(area ? { area } : {}), _: Date.now() },
        });
        return res.data;
    };
    // 퇴비 탐지 프로젝트 상세 조회 API
    // export const fetchDetectDataSetInfo = async (pcode) => {
    //     const url = `${apiUrl}/detect/project-list/?pcode=${pcode}`;
    //     const res = await axios.get(url, {
    //         headers: { Authorization: `Bearer ${getAccessToken()}` },
    //     });
    //     return res.data;
    // };
    // 퇴비 탐지 프로젝트 시작 API
    export const fetchDetectProjectStart = async (projectInfo) => {
        const url = `${apiUrl}/detect/start-project/`;
        const res = await axios.post(
          url,
          {
            project_info: projectInfo,
          },
          {
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
            },
          }
        );
        return res.data;
      };
    // 퇴비탐지 시 업로드 했던 이미지에 대한 정보 조회 API
        export const fetchDetectDataSetInfo = async (pcode, area) => {
            const url = `${apiUrl}/detect/drone-video/?pcode=${pcode}`;
            const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
            params: area ? { area } : undefined,
            });
            return res.data;
        };

         // 우선관리지역에 해당 하는 퇴비탐지 시 업로드 했던 이미지에 대한 정보 조회 API
         export const fetchDetectAreaDataSetInfo = async (priority_code) => {
          const url = `${apiUrl}/detect/drone-video/?priority_code=${priority_code}`;
          const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
          });
          return res.data;
      };



        // 퇴비탐지 프로젝트 삭제 
        export const fetchDetectProjectDelete = async (pcode, { cancel = false } = {}) => {
            const url = `${apiUrl}/detect/project-delete/${pcode}/${cancel ? '?cancel=true' : ''}`;
            const res = await axios.delete(url, {
            headers: { Authorization: `Bearer ${getAccessToken()}` },
            });
            return res.data;
        };


      
      // 위성 이미지 다운로드 작업 취소 API
      // deleteData가 false면 다운로드가 끝난 원본은 서버에 남긴다.
      export const fetchSatelliteProjectCancel = async (pcode, { deleteData = false } = {}) => {
        const url = `${apiUrl}/common/cancel-task/${pcode}/`;
        const res = await axios.delete(url, {
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        params: deleteData ? { delete: 1 } : undefined,
        });
        return res.data;
    };

    
      
    // -----------------------------
    // ✅ 센티널
    // -----------------------------
  // ✅ area 파라미터 추가
  export const fetchSatelliteDataSetList = async (area = "yeongju") => {
    const url = `${apiUrl}/common/sentinel-image-list/`;
    const res = await axios.get(url, {
      headers: { Authorization: `Bearer ${getAccessToken()}` },
      params: { area }, // 👈 GET 요청의 Query Params 추가
    });
    return res.data;
  };

    export const fetchDownloadSentinelImage = async (area, date) => {
        const url = `${apiUrl}/common/download-sentinel/${area}/${date}/`;
      
        const res = await axios.post(url, null, {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
        });
      
        return res.data;
      };

    // -----------------------------
    // ✅ api 관리 
    // -----------------------------

    // API Key 조회 (company 기반)
  export const fetchListApiKey = async (companyId) => {
      const url = `${apiUrl}/api-keys/?company=${companyId}`;
    
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      });
    
      return res.data;
    };
  

    //API Key 등록
   export const fetchRegisApiKey = async (api_key_id) => {
    const url = `${apiUrl}/api-keys/${api_key_id}/`;
  
    const res = await axios.post(url, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    });
  
    return res.data;
  };


  // API Key 수정
  export const patchApiKey = async (apiKeyId, payload) => {
    const url = `${apiUrl}/api-keys/${apiKeyId}/`;

    const res = await axios.patch(url, payload, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  };


  //API Key 삭제
  export const fetchDeleteApiKey = async (api_key_id) => {
    const url = `${apiUrl}/api-keys/${api_key_id}`;
  
    const res = await axios.delete(url,{
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    });
  
    return res.data;
  };
